import React from "react";

const LabelValue = ({
  id,
  label,
  value,
  className = "",
  valueClassName = "",
}) => {
  if (!value) return null;

  return (
    <div className={`${className}`}>
      <label
        htmlFor={id}
        className="mb-1 block text-sm text-labelColour whitespace-normal break-words"
      >
        {label}
      </label>

      <span className={`text-sm text-black ${valueClassName}`}>
        {value}
      </span>
    </div>
  );
};

export default LabelValue;
